import {AbstractControl, ValidatorFn} from '@angular/forms';

import * as moment_ from 'moment';

import {UnderEighteensValidatorKey} from './custom-validator-keys';

const moment = moment_;

export function UnderEighteensValidator(): ValidatorFn {
    return (control: AbstractControl): { [UnderEighteensValidatorKey]: boolean } | null => {
        const date = moment(control.value);

        if (!date.isValid()) {
            return {[UnderEighteensValidatorKey]: true};
        }

        const now = moment();
        const diff = now.diff(date, 'years');

        if (diff < 18) {
            return {[UnderEighteensValidatorKey]: true};
        }

        return null;
    };
}
